import { YieldCalculatorStyleTokens } from "@omni/ui/brand/productConfiguration/yieldCalculator/yieldCalculator.tokens";

export const YieldCalculatorStyles: YieldCalculatorStyleTokens = {
    submitButton: {
        color: "secondary"
    }
};
